export default __webpack_public_path__ + "static/media/home-ambient-glow.e90ee28d.png";